<div class="breadcrumb-area">
    <h1>Productos Favoritos</h1>
</div>

<div class="card mb-5">
    <div class="card-header">
        <h3> Productos favoritos por bodega </h3>
    </div>
    <div class="card-body">
        <!-- BODEGA -->
        <div class="row mb-3">
            <div class="col-sm-6 form-group">
                <label for="warehouse" class="form-label">
                    Bodega
                </label>
                <select name="warehouse" id="warehouse" class="form-select" [(ngModel)]="warehouse" (change)="changeWarehouse()">
                    <option [ngValue]="null">
                        Selecciona una bodega
                    </option>
                    <option *ngFor="let w of warehouses" [ngValue]="w.id">
                        {{w.code ? w.code + ' - ' : ''}}{{w.name}}
                    </option>
                </select>
            </div>
        </div>
        <div *ngIf="warehouse == null" class="text-muted mt-3">
            <i class="fa fa-circle-info"></i>
            Selecciona una bodega para consultar sus productos favoritos.
        </div>
        <ng-container *ngIf="warehouse != null">
            <div
                class="input-group input-group-sm mb-3">
                <label for="filterWord" class="input-group-text">
                    Filtra
                </label>
                <input type="text" [(ngModel)]="filterWord" (input)="filter()" name="filterWord" id="filterWord" 
                        placeholder="Ingresa el código, código de barras o nombre del producto" class="form-control">
            </div>
            <app-loading-animation
                *ngIf="loading"
                [height]="'10rem'">
            </app-loading-animation>
            <ng-container *ngIf="!loading">
                <div class="row">
                    <div class="col-sm">
                        <div class="table table-responsive" *ngIf="favorites.length > 0">
                            <table class="table">
                                <caption *ngIf="filterWord">
                                    Se muestran los resultados para {{filterWord}}
                                </caption>
                                <thead>
                                    <tr class="tr-middle">

                                        <th class="ta">
                                            Código
                                        </th>

                                        <th class="ta">
                                            Código de Barras
                                        </th>

                                        <th>
                                            Nombre
                                        </th>

                                        <th class="ta">
                                            Tipo
                                        </th>

                                        <th class="ta">
                                            Puede ser
                                            <br>

                                            <span class="can-be-title">
                                                <i class="fa-solid fa-cart-shopping text-warning"></i>
                                                Comprado
                                            </span>

                                            <span class="can-be-title">
                                                <i class="fa-solid fa-money-bill text-success"></i>
                                                Vendido
                                            </span>
                                        </th>

                                        <th class="ta">
                                            Familia
                                        </th>

                                        <th class="ta">
                                            Eliminar
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <ng-container
                                        *ngFor="let favorite of pagination.filter">
                                        <tr class="tr-middle">
                                            <td class="ta">
                                                {{favorite.product.code}}
                                            </td>
                                            <td class="ta">
                                                <ng-container
                                                    *ngIf="favorite.product.barCode">
                                                    <span *ngIf="!seeing[favorite.id]">
                                                        {{favorite.product.barCode}}
                                                    </span>
                                                    <span *ngIf="seeing[favorite.id]" class="barCode">
                                                        {{favorite.product.barCode}}
                                                    </span>
                                                    <span (click)="seeing[favorite.id] = !seeing[favorite.id]" class="clickeable text-info">
                                                        <i [ngClass]="seeing[favorite.id] ? 'fa fa-eye-slash' : 'fa fa-eye'"> </i>
                                                    </span>
                                                </ng-container>
                                                <ng-container *ngIf="!favorite.product.barCode">
                                                    <div class="superposition-parent with-hover" tooltip="No cuenta con código de barras">
                                                        <i class="fa fa-barcode"></i>
                                                        <i class="fa fa-question superposition-icon">
                                                        </i>
                                                    </div>
                                                </ng-container>
                                            </td>
                                            <td class="limit-td">
                                                {{favorite.product.name}}
                                            </td>
                                            <td class="ta">
                                                {{favorite.product.type == 'b' ? 'Bien' : 'Servicio'}}
                                            </td>
                                            <td class="ta">
                                                <div class="can-be">
                                                    <i *ngIf="favorite.product.bought" tooltip="Comprado" class="fa-solid fa-cart-shopping text-warning with-hover">
                                                    </i>
                                                    <i *ngIf="favorite.product.sold" tooltip="Vendido" class="fa-solid fa-money-bill text-success with-hover">
                                                    </i>
                                                </div>
                                            </td>
                                            <td class="ta">
                                                <ng-container *ngIf="favorite.product.family">
                                                    {{favorite.product.family}}
                                                </ng-container>
                                                <ng-container *ngIf="!favorite.product.family">
                                                    <span class="opacity-30">
                                                        --
                                                    </span>
                                                </ng-container>
                                            </td>
                                            
                                            <td class="ta">
                                                <span *ngIf="!deleting[favorite.id]" class="clickeable text-danger" 
                                                        tooltip="Eliminar de favoritos" (click)="deleteFavorite(favorite)">
                                                    <i class="fa fa-trash"></i>
                                                </span>
                                                <span *ngIf="deleting[favorite.id]" class="spinner-border spinner-border-sm" aria-hidden="true">
                                                </span>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                        <div *ngIf="favorites.length == 0">
                            <i class="fa fa-circle-info"></i>
                            Esta bodega aún no tiene productos favoritos.
                        </div>
                        <div *ngIf=" favorites.length > 0 && pagination.total.length == 0 ">
                            <i class="fa fa-circle-info"></i>
                            No existen productos para el filtro
                            <strong>{{filterWord}}</strong>.
                        </div>
                    </div>
                    <app-pagination-custom
                        *ngIf="pagination.total.length > 0"
                        [elements]="pagination">
                    </app-pagination-custom>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>